<!--
 * @LastEditors: 八千
 -->
<template>
  <div>
    <div class="container1920sub footerlist">
      <!-- PC端图标 -->
      <div class="row relative hide-on-mobile">
        <div class="absolute gzwm">
          <p class="ab1">关注我们</p>
          <p class="clearfix weixinicon">
            <img
              class="fn-right"
              style="cursor: pointer"
              src="./weixinicon.png"
              alt
            />
          </p>
          <p class="ab2">微信</p>
          <p class="clearfix weiboicon">
<!--            <a href="http://weibo.com/svwrelease" target="_blank">-->
            <a href="https://weibo.com/u/3865917418" target="_blank">
              <img class="fn-right" src="./weiboicon.png" alt />
            </a>
          </p>
          <p class="ab3">微博</p>
          <img class="qr" src="./weixincode.png" />
          <img class="qr2_old" src="./weibocode.png" style="display: none" />
        </div>
      </div>
      <div class="row foot-mobile">
        <div class="one fourth two-up-mobile" style="width: 16.67%">
          <ul :class="showFlag0 ? 'active' : ''">
            <li @click="show(0)">
              <b>了解我们</b>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/module/about.html"
                >企业概述</a
              >
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/about/intro.html"
                >企业文化与战略</a
              >
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/about/history.html"
                >发展历程</a
              >
            </li>
            <li>
              <a href="https://www.csvw.com/special3/#/factory"
                >工厂布局</a
              >
            </li>
            <li>
              <a href="https://www.csvw.com/csvw/thirdpart/responsibility/"
                >社会责任</a
              >
            </li>
            <li class="hide-on-mobile">
              <a href="https://www.csvw.com/csvw-website/about/report.html"
                >企业年刊</a
              >
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/about/honor.html"
                >企业荣誉</a
              >
            </li>
          </ul>
        </div>
        <div class="one fourth two-up-mobile" style="width: 16.67%">
          <ul :class="showFlag1 ? 'active' : ''">
            <li @click="show(1)">
              <b>新闻中心</b>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/news/company-news.html">企业新闻</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/news/activities.html">专题报道</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/news/company-bulletin.html">企业公告</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/news/dz-brand-news.html?brand=vw&title=大众品牌新闻_上汽大众官网">大众品牌新闻</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/news/audi-brand-news.html?brand=audi&title=奥迪品牌新闻_上汽大众官网">奥迪品牌新闻</a>
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/news/skoda-brand-news.html?brand=skoda&title=斯柯达品牌新闻_上汽大众官网">斯柯达品牌新闻</a>
            </li>
          </ul>
        </div>
        <div class="one fourth two-up-mobile" style="width:16.60%">
          <ul :class="showFlag5 ? 'active':''">
            <li @click="show(5)">
              <b>下载中心</b>
            </li>
            <li>
              <a href="/svwmedia-website/index/index.html#vehicle" target="_blank">车型资料</a>
            </li>
            <li>
              <a href="/svwmedia-website/index/index.html#anchor" target="_blank">企业资料</a>
            </li>
          </ul>
        </div>
        <div class="one fourth two-up-mobile" style="width: 16.67%">
          <ul :class="showFlag2 ? 'active' : ''">
            <li @click="show(2)">
              <b>客户服务</b>
            </li>
            <li>
              <a
                href="https://www.csvw.com/csvw-website/footinfo/environment.html"
                >环保信息公开</a
              >
            </li>
            <li>
              <a
                href="https://www.csvw.com/epps-website/page/publicity/battery.jsp"
                >动力蓄电池回收服务网点</a
              >
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/footinfo/download.html"
                >下载专区</a
              >
            </li>
            <li>
              <a href="https://www.csvw.com/csvw-website/footinfo/taxfree.html"
                >留学生免税车</a
              >
            </li>
            <li>
              <a
                href="https://online-service.csvw.com/any800/echatManager.do?codeKey=10&companyPk=ff8080815cd4384c015cd44ba48b0002"
                >在线客服</a
              >
            </li>
            <li class="hide-on-mobile">&nbsp;</li>
            <li class="hide-on-mobile">&nbsp;</li>
            <li class="hide">
              <a href>网站地图</a>
            </li>
          </ul>
          <!-- <ul :class="showFlag3 ? 'active':''">
            <li @click="show(3)">
              <b>加入我们</b>
            </li>
            <li>
              <a href="/special3/#/join-us?type=Recruitment">企业招聘网站</a>
            </li>
            <li>
              <a href="/special3/#/join-us?type=dealerRecruitment">经销商招募</a>
            </li>
          </ul> -->
        </div>
        <div
          class="one fourth two-up-mobile"
          :class="showFlag4 ? 'active' : ''"
          style="width: 16.67%"
        >
          <ul :class="showFlag4 ? 'active' : ''">
            <li @click="show(4)">
              <b>友情链接</b>
            </li>
            <li>
              <a href="http://www.saicmotor.com/chinese/" target="_blank"
                >上汽集团网站</a
              >
            </li>
            <li>
              <a
                href="http://www.volkswagengroupchina.com.cn/content/vgc/content/zh/homepage.html"
                target="_blank"
                >大众汽车集团（中国）网站</a
              >
            </li>
            <li>
              <a href="https://www.svw-volkswagen.com" target="_blank"
                >大众品牌官网</a
              >
            </li>
            <li>
              <a href="http://saic-audi.cn/" target="_blank">奥迪品牌官网</a>
            </li>
            <li>
              <a href="https://www.saicskoda.com.cn" target="_blank"
                >斯柯达品牌官网</a
              >
            </li>
          </ul>
          <!-- 移动端图标 -->
          <ul class="focusMe">
            <li class="mobile-only">
              <b>关注我们</b>
            </li>
            <li class="mobile-only shuangwei">
              <img
                class="mweixin"
                style="cursor: pointer"
                src="./weixinicon.png"
                alt
              />&nbsp;
              <!--            <a href="http://weibo.com/svwrelease" target="_blank">-->
              <a href="https://weibo.com/u/3865917418" target="_blank">
                <img class="mweibo" src="./weiboicon.png" alt />
              </a>

              <img
                class="qrm"
                src="./weixincode.png"
                style="left: 129px; top: -57px"
              />
              <img
                class="qr2m_old"
                src="./weibocode.png"
                style="display: none"
              />
            </li>
          </ul>
        </div>
        <div
          class="one fourth two-up-mobile"
          :class="showFlag4 ? 'active' : ''"
          style="width: 16.60%"
        >
          <ul :class="showFlag3 ? 'active' : ''">
            <li @click="show(3)">
              <b>加入我们</b>
            </li>
            <li>
              <a
                href="/special3/#/join-us?type=Recruitment"
                >企业招聘网站</a
              >
            </li>
            <li>
              <a href="/special3/#/join-us?type=dealerRecruitment"
                >经销商招募</a
              >
            </li>
            <li>
              <a href="/special3/#/join-us?type=agentRecruitment"
                >代理商招募</a
              >
            </li>
          </ul>
        </div>
      </div>
      <!-- 公共部分 -->
      <div class="row mtll lm_foot" style="margin-top: 26px !important">
        <div class="one whole">
          <div class="call400" style="font-size: 14px; color: #2b2b2d">
            大众品牌、斯柯达品牌客户服务热线：
            <span
              style="
                font-size: 14px;
                font-weight: 900;
                color: #2b2b2d;
                padding-left: 0;
              "
              >400-820-1111</span
            >
          </div>
        </div>
        <div class="one whole">
          <div
            class="call400"
            style="font-size: 14px; color: #2b2b2d; margin-top: 10px"
          >
            奥迪品牌客户服务热线：
            <span
              style="
                font-size: 14px;
                font-weight: 900;
                color: #2b2b2d;
                padding-left: 0;
              "
              >400-820-1118</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="container1920sub footinfo">
      <div class="row">
        <div
          class="one half one-up-mobile one-up-mobile2"
          style="width: 75%; padding-left: 20%; text-align: center"
        >
          <div class="p1">
            上汽大众汽车有限公司版权所有
            <a href="https://beian.miit.gov.cn/" target="_blank"
              >沪ICP备15002176号-1</a
            >
          </div>
          <div class="p2">
            <img src="./jinghuiicon.png" class="inline-block" />
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011402001355"
              target="_blank"
              >沪公网安备 31011402001355 号</a
            >
          </div>
        </div>
        <div class="one half one-up-mobile" style="width: 25%; float: right">
          <div class="p3">
            <a href="https://www.csvw.com/csvw-website/footinfo/law.html"
              >法律声明</a
            >
            ｜
            <a href="https://www.csvw.com/csvw-website/footinfo/privacy.html"
              >隐私政策</a
            >
            ｜
            <a href="https://www.csvw.com/csvw-website/footinfo/userAgree.html"
              >用户协议</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- <img src="../assets/images/backTop.png" id="backTop" v-show="isMobie && top" @click="backTop"> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      isMobie: false,
      top: false,
      showFlag0: false,
      showFlag1: false,
      showFlag2: false,
      showFlag3: false,
      showFlag4: false,
      showFlag5: false,
    };
  },
  beforeMount() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.checkBrowser();
  },
  methods: {
    handleScroll() {
      //改变元素#searchBar的top值
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 420) {
        this.top = true;
      } else {
        this.top = false;
      }
    },
    checkBrowser() {
      var userAgent = navigator.userAgent;
      var os = {};
      os.android =
        userAgent.match(/(Android)\s+([\d.]+)/) ||
        userAgent.match(/Silk-Accelerated/)
          ? true
          : false;
      os.androidICS =
        os.android && userAgent.match(/(Android)\s4/) ? true : false;
      os.ipad = userAgent.match(/(iPad).*OS\s([\d_]+)/) ? true : false;
      os.iphone =
        !os.ipad && userAgent.match(/(iPhone\sOS)\s([\d_]+)/) ? true : false;
      os.ios = os.ipad || os.iphone;
      os.wp =
        userAgent.match(/Windows Phone/) || userAgent.match(/IEMobile/)
          ? true
          : false;
      os.supportsTouch =
        (window.DocumentTouch && document instanceof window.DocumentTouch) ||
        "ontouchstart" in window;
      os.lessIE10 = document.all && !window.atob; //Internet Explorer ≤ 9
      os.lessIE9 = document.all && !document.addEventListener; //Internet Explorer ≤ 8
      os.isWeixin =
        userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
      var isMobie = os.android || os.iphone || os.wp;
      this.isMobie = isMobie;
    },
    backTop() {
      this.$("html,body").animate({ scrollTop: "0px" }, "slow");
    },
    show(id) {
      let ulId = "";
      for (let i = 0; i < 6; i++) {
        ulId = "showFlag" + i;
        if (id == i) {
          this[ulId] = !this[ulId];
        } else {
          this[ulId] = false;
        }
      }
    },
  },
  destroyed() {
    //离开该页面需要移除这个监听的事件
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped src="../assets/less/about.css"></style>
<style scoped src="../assets/less/groundwork.css"></style>
<style scoped src="../assets/less/main.css"></style>
<style scoped src="../assets/less/swiper.min.css"></style>
<style lang="less" scoped>
#backTop {
  display: block;
  width: 55px;
  height: 55px;
  position: fixed;
  bottom: 30px;
  right: 10px;
  z-index: 100;
}

.weixinicon ~ .qr {
  display: none;
}

.weixinicon:hover ~ .qr {
  display: block;
}

.mweixin ~ .qrm {
  display: none;
}

.mweixin:hover ~ .qrm {
  display: block;
}

@media (max-width: 480px) {
  .foot-mobile ul {
    max-height: 50px;
    overflow: hidden;
    transition: max-height 0.3s linear;
  }
  .foot-mobile ul li {
    &:first-child {
      height: auto;
      position: relative;
      &::after {
        content: "";
        display: block;
        width: 12px;
        height: 6px;
        background: url("../assets/images/arrow.png") no-repeat;
        background-size: 12px 6px;
        position: absolute;
        right: 15px;
        top: 50%;
        margin-top: -3px;
        transition: all 0.3s ease-out;
      }
    }
  }
  .foot-mobile ul.active {
    max-height: 300px;
    transition: max-height 0.3s linear;
    padding-bottom: 10px;
    li {
      height: auto;
    }
    li:first-child::after {
      transform: rotate(180deg);
    }
  }
  .foot-mobile .focusMe {
    max-height: 200px;
    padding-bottom: 20px;
    li {
      height: auto;
    }
    li:first-child::after {
      display: none;
    }
  }
  .lm_foot {
    margin-top: 20px !important;
    margin-bottom: 15px;
  }

  .one-up-mobile2 {
    clear: both!important;
    padding-left: 0!important;
  }
}
</style>